import * as React from 'react';
import Typography from '@mui/material/Typography';

const FooterText = ({ children, spaced }) => (
  <Typography variant="body2" color="text.secondary" align="center" sx={{ pt: spaced ? 4 : 0 }} >
    { children }
  </Typography>
);

export default FooterText;